import { Company } from "./Company"
import { Service } from "./Service";

export class ServiceCharge {
    id: number;
    invoice_pdf: string;

    constructor(id: number, invoice_pdf: string) {
        this.id = id;
        this.invoice_pdf = invoice_pdf;
    }

    clone(): ServiceCharge {
        return new ServiceCharge(this.id, this.invoice_pdf);
    }
    toPrimitive() {
        return {
            id: this.id,
            invoice_pdf: this.invoice_pdf
        }
    }
}

export class ServiceDelivery {
    sd_id: number;
    user_id: number;
    contract_type: string;
    status: boolean;
    credits: number;
    companies: Company[];
    charge: ServiceCharge;
    service: Service;
    paid_extra_users: number;
    users_num: number;
    start_date: Date;

    constructor(
        sd_id: number, 
        user_id: number,
        contract_type: string,
        status: boolean,
        credits: number, 
        companies: Company[],
        charge?: ServiceCharge,
        service?: Service,
        paid_extra_users?: number,
        users_num?: number,
        start_date?: Date,
    ) {
        this.sd_id = sd_id;
        this.user_id = user_id;
        this.contract_type = contract_type;
        this.status = status;
        this.credits = credits
        this.companies = companies;
        this.charge = charge;
        this.service = service;
        this.paid_extra_users = paid_extra_users;
        this.users_num = users_num;
        this.start_date = start_date;
    }
    
    get id() {
        return this.sd_id;
    }

    clone(): ServiceDelivery {
        return new ServiceDelivery(
            this.sd_id,
            this.user_id,
            this.contract_type,
            this.status,
            this.credits,
            this.companies?.map(company => company.clone()),
            this.charge?.clone(),
            this.service?.clone?.(),
            this.paid_extra_users,
            this.users_num,
            this.start_date,
        )
    }

    toPrimitive() {
        return {
            sd_id: this.sd_id,
            user_id: this.user_id,
            contract_type: this.contract_type,
            status: this.status,
            credits: this.credits,
            companies: this.companies,
            charge: this.charge,
            service: this.service,
            paid_extra_users: this.paid_extra_users,
            users_num: this.users_num,
            start_date: this.start_date,
        }
    }
    
    static fromPrimitive(raw_sd: any): ServiceDelivery {
        const companies = (raw_sd.companies || []).map(c => new Company(c.id, c.name, c.user_id));

        const charge = raw_sd.charge ? new ServiceCharge(raw_sd.charge.id, raw_sd.charge.invoice_pdf) : undefined;
        const service = raw_sd.contract_type ? new Service( raw_sd.contract_type.id, raw_sd.contract_type.name, raw_sd.contract_type.kind, raw_sd.contract_type.product_code, raw_sd.contract_type.limit_users, raw_sd.contract_type.extra_users_price ) : undefined;

        return new ServiceDelivery(
            raw_sd.id, // sd_id
            raw_sd.user_id ?? 0,
            raw_sd.contract_type?.name || '',
            raw_sd.status ?? false,
            raw_sd.credits ?? 0,
            companies,
            charge,
            service,
            raw_sd.paid_extra_users ?? 0,
            raw_sd.users_num ?? 0,
            raw_sd.start_date ?? new Date(),
        );
    }
}

export interface SelectEInvContractPopup {
    show(): Promise<any | null>
    close(company)
}